export var data = [
  // user 1
  {
    userId: 1,
    userName: "Sahil",
    userAvatar: "./img/useravatar.jpg",
    userShow: true,
    userMessages: [
      {
        message: "Hello Sahil!",
        messageType: "send",
      },
      {
        message: "Hello Anoop!",
        messageType: "get",
      },
      {
        message: "How are you?",
        messageType: "get",
      },
    ],
  },

  // user 2
  {
    userId: 2,
    userName: "Hitesh",
    userAvatar: "./img/useravatar.jpg",
    userShow: true,
    userMessages: [
      {
        message: "Hello Hitesh!",
        messageType: "send",
      },
      {
        message: "Hello Anoop!",
        messageType: "get",
      },
      {
        message: "How are you?",
        messageType: "get",
      },
    ],
  },

  // user 3
  {
    userId: 3,
    userName: "Deepak Sir",
    userAvatar: "./img/useravatar.jpg",
    userShow: true,
    userMessages: [
      {
        message: "Hello Deepak!",
        messageType: "send",
      },
      {
        message: "Hello Anoop!",
        messageType: "get",
      },
      {
        message: "How are you?",
        messageType: "get",
      },
    ],
  },

  // user 4
  {
    userId: 4,
    userName: "Kismat",
    userAvatar: "./img/useravatar.jpg",
    userShow: true,
    userMessages: [
      {
        message: "Hello Kismat!",
        messageType: "send",
      },
      {
        message: "Hello Anoop!",
        messageType: "get",
      },
      {
        message: "How are you?",
        messageType: "get",
      },
    ],
  },

  // user 5
  {
    userId: 5,
    userName: "Ankit",
    userAvatar: "./img/useravatar.jpg",
    userShow: false,
    userMessages: [],
  },

  // user 6
  {
    userId: 6,
    userName: "Vikash Sir",
    userAvatar: "./img/useravatar.jpg",
    userShow: false,
    userMessages: [],
  },

  // user 7
  {
    userId: 7,
    userName: "Sagar Sir",
    userAvatar: "./img/useravatar.jpg",
    userShow: false,
    userMessages: [],
  },

  // user 8
  {
    userId: 8,
    userName: "Neeraj Sir",
    userAvatar: "./img/useravatar.jpg",
    userShow: false,
    userMessages: [],
  },

  // user 9
  {
    userId: 9,
    userName: "Sheetal Mam",
    userAvatar: "./img/useravatar.jpg",
    userShow: false,
    userMessages: [],
  },

  // user 10
  {
    userId: 10,
    userName: "Pooja Mam",
    userAvatar: "./img/useravatar.jpg",
    userShow: false,
    userMessages: [],
  },

  // user 11
  {
    userId: 11,
    userName: "Ajay",
    userAvatar: "./img/useravatar.jpg",
    userShow: true,
    userMessages: [
      {
        message: "Hello Ajay!",
        messageType: "send",
      },
      {
        message: "Hello Anoop!",
        messageType: "get",
      },
      {
        message: "How are you?",
        messageType: "get",
      },
    ],
  },

  // user 12
  {
    userId: 12,
    userName: "Dheeraj",
    userAvatar: "./img/useravatar.jpg",
    userShow: true,
    userMessages: [
      {
        message: "Hello Dheeraj!",
        messageType: "send",
      },
      {
        message: "Hello Anoop!",
        messageType: "get",
      },
      {
        message: "How are you?",
        messageType: "get",
      },
    ],
  },

  // user 13
  {
    userId: 13,
    userName: "Rahul Sir",
    userAvatar: "./img/useravatar.jpg",
    userShow: true,
    userMessages: [
      {
        message: "Hello Rahul Sir!",
        messageType: "send",
      },
      {
        message: "Hello Anoop!",
        messageType: "get",
      },
      {
        message: "How are you?",
        messageType: "get",
      },
    ],
  },

  // user 14
  {
    userId: 14,
    userName: "Yakshit",
    userAvatar: "./img/useravatar.jpg",
    userShow: true,
    userMessages: [
      {
        message: "Hello Yakshit!",
        messageType: "send",
      },
      {
        message: "Hello Anoop!",
        messageType: "get",
      },
      {
        message: "How are you?",
        messageType: "get",
      },
    ],
  },
];
